import { IntercomManager } from '../native/intercomManager';
import { LocalizePropType } from '../HoC/withTextLocalizer';

// Inline to avoid a require cycle: redux -> user/actions -> userHelpers -> onBoardingHelper -> redux
const getFirstStepsChallenge = (
  challenges: Array<any>
): any | null | undefined =>
  challenges?.find((challenge) => challenge?.type === 'firstSteps');

export const anyFirstStepsOpen = (user: any): boolean => {
  const { challenges } = user;
  const challenge = getFirstStepsChallenge(challenges);

  if (challenge) {
    return challenge.tasks.some(
      (it: { status: string }) => it.status === 'open'
    );
  }

  return true;
};

export const isFirstStepsCompleted = (user: any): boolean => {
  const { challenges } = user;
  const challenge = getFirstStepsChallenge(challenges);

  if (challenge) {
    return challenge.tasks.every(
      (it: { status: string }) => it.status === 'completed'
    );
  }

  return true;
};

export const isDocumentAddressProof = (addressOnBoardingType: any): boolean =>
  addressOnBoardingType && addressOnBoardingType === 'document';

export const registerIntercomUser = (
  intercomHandlingMode: string | null | undefined,
  user: any | null | undefined,
  basicAuth: string | null | undefined,
  supportContacted: boolean,
  isIntercomUserRegistered: boolean,
  setIsIntercomUserRegistered: (isIntercomUserRegistered: boolean) => void,
  brandCode?: string | null
) => {
  // Always try to ensure brand attribute is set on current Intercom user
  try {
    IntercomManager.updateBrand(brandCode);
  } catch {
    // no-op
  }
  switch (intercomHandlingMode) {
    case 'always':
      if (!isIntercomUserRegistered) {
        IntercomManager.registerIntercomUser(user, brandCode).then((result) => {
          setIsIntercomUserRegistered(result);
        });
      }
      break;

    case 'onLogin':
      if (user && basicAuth && !isIntercomUserRegistered) {
        IntercomManager.registerIntercomUser(user, brandCode).then((result) => {
          setIsIntercomUserRegistered(result);
        });
      }

      break;

    case 'onContactSupport':
      if (supportContacted && !isIntercomUserRegistered) {
        IntercomManager.registerIntercomUser(user, brandCode).then((result) => {
          setIsIntercomUserRegistered(result);
        });
      }

      break;

    default:
      break;
  }
};

export const showTariffRequiredDialog = async (
  localize: LocalizePropType,
  yesAction: () => void,
  violation: string
) => {
  const { showAlert } = await import('./showAlert');

  showAlert(
    '',
    localize(violation),
    localize('dialog.tariff.add'),
    () => yesAction(),
    localize('cancel'),
    () => {}
  );
};

export const showSchufaRequiredDialog = async (
  localize: LocalizePropType,
  yesAction: () => void,
  violation: string
) => {
  const { showAlert } = await import('./showAlert');

  showAlert(
    '',
    localize(violation),
    localize('dialog.schufa.add'),
    () => yesAction(),
    localize('cancel'),
    () => {}
  );
};

export const showResetPasswordRequiredDialog = async (
  localize: LocalizePropType,
  yesAction: () => void,
  violation: string
) => {
  const { showAlert } = await import('./showAlert');

  showAlert(
    '',
    localize(violation),
    localize('new.password.yes'),
    () => yesAction(),
    localize('cancel'),
    () => {}
  );
};

export const getAge = (dateOfBirth: string): number => {
  const dob = new Date(dateOfBirth);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--;
  }
  return age;
};
